
import { Component, Prop, Vue } from 'vue-property-decorator'

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function emphasize(html: string): string {
  // Markdown-ish **bold** → Excel red emphasis
  let out = html.replace(
    /\*\*(.+?)\*\*/g,
    '<strong class="dx-alert-em">$1</strong>'
  )

  // Full RADV header line
  out = out.replace(
    /^(RADV ALERT[\s\S]*?)(?=\n|$)/i,
    '<strong class="dx-alert-em">$1</strong>'
  )

  // IMPORTANT: label
  out = out.replace(
    /\b(IMPORTANT:)/gi,
    '<strong class="dx-alert-em">$1</strong>'
  )

  // Closing CMS recovery sentence (as in Excel sample)
  out = out.replace(
    /(Unsupported or inaccurate diagnosis coding may result in CMS payment recovery\.)/gi,
    '<strong class="dx-alert-em">$1</strong>'
  )

  return out
}

function formatDiagnosticAlertHtml(raw: string): string {
  if (!raw) return ''

  const escaped = escapeHtml(raw.replace(/\r\n/g, '\n').replace(/\r/g, '\n'))
  const emphasized = emphasize(escaped)
  const lines = emphasized.split('\n')

  const parts: string[] = []
  let listOpen = false

  const closeList = () => {
    if (listOpen) {
      parts.push('</ul>')
      listOpen = false
    }
  }

  for (const line of lines) {
    const trimmed = line.trim()
    if (!trimmed) {
      closeList()
      continue
    }

    const bullet = trimmed.match(/^(?:•|·|-\s+|–\s+)(.+)$/)
    if (bullet) {
      if (!listOpen) {
        parts.push('<ul class="dx-alert-list">')
        listOpen = true
      }
      parts.push(`<li>${bullet[1]}</li>`)
      continue
    }

    closeList()
    parts.push(`<p class="dx-alert-p">${trimmed}</p>`)
  }
  closeList()

  return parts.join('')
}

/**
 * Renders diagnostic Alert text approximating Excel text formatting:
 * indentation/bullets, bold red emphasis on key phrases / **markers**.
 *
 * Excel cell fill colors are NOT stored in the DB Alert column (plain text).
 */
@Component
export default class DxAlertDisplay extends Vue {
  @Prop({ type: String, default: '' }) readonly text!: string
  @Prop({ type: Boolean, default: true }) readonly compact!: boolean

  get normalized(): string {
    return (this.text || '').trim()
  }

  get formattedHtml(): string {
    return formatDiagnosticAlertHtml(this.normalized)
  }
}
